import { create } from 'zustand';

interface PermissionState {
  permissions: string[];
  roles: string[];
  isReady: boolean;
  setPermissionsAndRoles: (permissions: string[], roles: string[]) => void;
  hasPermission: (permission: string, {
    adminPass
  }?: { adminPass?: boolean }) => boolean;
  hasRole: (role: string) => boolean;
  hasRoles: (roles: string[], requireAll?: boolean) => boolean;
}

export const usePermissionStore = create<PermissionState>((set, get) => ({
  permissions: [],
  roles: [],
  isReady: false,
  setPermissionsAndRoles: (permissions, roles) => set({ permissions, roles, isReady: true }),
  hasPermission: (permission, {
    adminPass = true
  }: { adminPass?: boolean } = {}) => {
    const { permissions, roles } = get();
    if (adminPass && roles.includes('admin')) return true; // Admin has all permissions
    return permissions.includes(permission);
  },
  hasRole: (role) => {
    const { roles } = get();
    return roles.includes(role);
  },
  hasRoles: (requiredRoles, requireAll = false) => {
    const { roles } = get();
    if (requireAll) {
      return requiredRoles.every(role => roles.includes(role));
    }
    return requiredRoles.some(role => roles.includes(role));
  }
}));